import { useMemo } from 'react';

// Redux
import { useDispatch, useSelector } from 'react-redux';

import {
  setPage,
  setLimit,
  setTotal,
  setColumnVisibility,
  setFreebetTableFilters,
  setClearFreebetTableFilters,
} from '@Modal/reducers/freebets/freebetTableSlice';

// Types
import { StoreInterface } from 'src/app/types';
import { FilterItemType } from '@Modal/reducers/types';

export const useFreebetsTable = () => {
  const dispatch = useDispatch();

  const {
    limit,
    page,
    total,
    selectedFilters,
    columnVisibility,
    freebetTableFilters,
    columnVisibilityOptions,
  } = useSelector((state: StoreInterface) => state?.freebetsTable);

  const freebetsListFilters = useMemo(() => {
    const columnVisibilityStrArr = Array.from(Object.values(columnVisibility)).map((filt) => filt);
    return columnVisibilityStrArr as string[];
  }, [columnVisibility]);

  const handleApplyColumnVisibility = (column: string[]) => {
    const newVisibleColumns = [...freebetsListFilters, ...column];
    if (freebetsListFilters.filter((col) => column.includes(col)).length > 0) {
      const filteredNewVisibleColumns = freebetsListFilters.filter((col) => col !== column[0]);
      dispatch(setColumnVisibility(filteredNewVisibleColumns));
    } else {
      dispatch(setColumnVisibility(newVisibleColumns));
    }
  };

  const visiblityCustomizable = useMemo(
    () => ({
      value: columnVisibility,
      options: columnVisibilityOptions,
      apply: (value: string[]) => handleApplyColumnVisibility(value),
    }),
    [columnVisibility, columnVisibilityOptions]
  );

  const handleFilterSelect = (filter: FilterItemType) => {
    dispatch(setFreebetTableFilters(filter));
  };

  const handleClearFreebetTableFilters = () => {
    dispatch(setClearFreebetTableFilters());
  };

  return {
    // State
    limit,
    page,
    total,
    selectedFilters,
    columnVisibility,
    freebetTableFilters,
    freebetsListFilters,
    visiblityCustomizable,
    columnVisibilityOptions,
    // Actions
    setPage,
    setLimit,
    setTotal,
    setFreebetTableFilters,
    setClearFreebetTableFilters,
    // Handlers
    handleFilterSelect,
    handleApplyColumnVisibility,
    handleClearFreebetTableFilters,
  };
};
